// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/design-system/components/data-display/StatusChip.jsx

import React from "react";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

export default function StatusChip({
  children,
  tone = "neutral",
  presentation = "soft",
  dot = false,
  icon = null,
  className = "",
}) {
  return (
    <span
      className={joinClassNames(
        "oasys-status-chip",
        `oasys-status-chip--${tone}`,
        `oasys-status-chip--${presentation}`,
        dot && "oasys-status-chip--dot",
        className
      )}
    >
      {icon ? (
        <span className="oasys-status-chip__icon" aria-hidden="true">
          {icon}
        </span>
      ) : null}

      <span>{children}</span>
    </span>
  );
}
